import { render, staticRenderFns } from "./MoreDirFileDataDialog.vue?vue&type=template&id=49f87a4c&"
import script from "./MoreDirFileDataDialog.vue?vue&type=script&lang=js&"
export * from "./MoreDirFileDataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports